import React from 'react'
import { Dialog, DialogProps, IconButton, Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'

export interface ModalProps extends Omit<DialogProps, 'title'> {
  title?: React.ReactNode
  onClose: () => void
}

const Paper = styled(Box)({
  backgroundColor: 'var(--ds-surface)',
  color: 'var(--ds-ink)',
  borderRadius: 'var(--ds-radius-lg)',
  padding: 'var(--ds-space-5)',
  maxWidth: 480,
  width: '100%',
  boxShadow: 'var(--ds-shadow-lift)',
})

const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 'var(--ds-space-4)',
  gap: 'var(--ds-space-3)',
})

export function Modal({ title, onClose, children, open, ...rest }: ModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: 'transparent',
          boxShadow: 'none',
          margin: 2,
          maxWidth: 520,
          width: '100%',
        },
      }}
      {...rest}
    >
      <Paper>
        {(title || onClose) && (
          <Header>
            <Typography variant='h2' sx={{ fontSize: 22, m: 0 }}>
              {title}
            </Typography>
            <IconButton aria-label='Close' onClick={onClose} size='small'>
              <CloseIcon fontSize='small' />
            </IconButton>
          </Header>
        )}
        {children}
      </Paper>
    </Dialog>
  )
}
